import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('bng-new', 19);

/**
 * @param {Object} params
 * @param {string} params.ctaName
 * @param {string} params.pageName
 * @param {string} params.section
 * @param {string} params.targetUrl
 */
export const clickOnCta = (params) => {
    const {ctaName, pageName, section, targetUrl} = params;
    biLogger.log({
        evid: 5301, 
        ctaName,
        pageName,
        section,
        targetUrl
    })
}

/**
 * @param {Object} params
 * @param {string} params.industry
 * @param {string} params.mainCategory
 * @param {string} params.keyword
 * @param {string} params.pageName
 */
export const generateName = (params) => {
    biLogger.log({
        evid: 5302, 
        industry: params.industry,
        mainCategory: params.mainCategory,
        keyword: params.keyword,
        pageName: params.pageName
    })
}


/**
 * @param {Object} params
 * @param {string} params.industry
 * @param {string} params.mainCategory
 * @param {string} params.query
 * @param {string} params.pageName
 */
export const industrySelected = (params) => {
    biLogger.log({
        evid: 5307, 
        industry: params.industry,
        mainCategory: params.mainCategory,
        query: params.query,
        pageName: params.pageName
    })
}


/**
 * @param {Object} params
 * @param {string} params.query
 * @param {string} params.pageName
 */
export const keywordTyped = (params) => {
    biLogger.log({
        evid: 5306, 
        query: params.query,
        pageName: params.pageName
    })
}

/**
 * @param {Object} params
 * @param {string} params.industry
 * @param {string} params.mainCategory
 * @param {string} params.businessName
 * @param {string} params.keyword
 */
export const modalView = (params) => {
    const {businessName, industry, mainCategory, keyword} = params;
    biLogger.log({
        evid: 5304, 
        keyword,
        businessName,
        industry,
        mainCategory
    })
}

/**
 * @param {Object} params
 * @param {string} params.businessName
 * @param {string} params.industry
 * @param {string} params.ctaType
 * @param {string} params.keyword
 * @param {string} params.mainCategory
 * @param {string} params.target_url
 */
export const clickOnModal = (params) => {
    const {businessName, industry, mainCategory, keyword, ctaType, target_url} = params;
    biLogger.log({
        evid: 5305, 
        businessName,
        ctaType,
        industry,
        keyword,
        mainCategory,
        target_url,
    })
}